

export default {
  SET_ITEMS(state, payload) {
    state.secteurs = payload
  },

  SET_ITEMS_WITH_INTERVENTIONS(state, payload) {
    state.secteursWithInterventions = payload
  },

  ADD_ITEM(state, payload) {
    state.secteurs.push(payload)
  },

  UPDATE_ITEM(state, payload) {
      const ItemIndex = state.secteurs.findIndex((p) => p.id == payload.id)
      Object.assign(state.secteurs[ItemIndex], payload)
  },

  REMOVE_ITEM(state, itemId) {
      const ItemIndex = state.secteurs.findIndex((p) => p.id == itemId)
      state.secteurs.splice(ItemIndex, 1)
  }
}
